import React, { useState, useEffect, useRef, useCallback } from 'react';
import { ButtonGroup, Button, Tabs, Tab } from '@mui/material';
import Home from '../../../components/Home/HomeBox'
import CaseloadReport from '../../../components/Reports_V2/CaseloadReport'
import TimesheetsReport from '../../../components/Reports_V2/TimesheetsReport'
import MTSummaryReport from '../../../components/Reports_V2/SupportCoordinationReports/MTSummaryReport'
import IRecordSync from '../../../components/forms/BulkUploadForm/IRecordSync'
import SupportCoordinatorManagement from '../../Manager/SupportCoordinatorManagement';
import SupportCoordinatorCustomers from '../../SupportCoordinator/SupportCoordinatorCustomers'
import NewNote from '../../SupportCoordinator/Modals/NewNote';
import NewTask from '../../SupportCoordinator/Modals/NewTask';
import NewTimesheet from '../../SupportCoordinator/Modals/NewTimesheet';
import Upload from '../../SupportCoordinator/Modals/Upload';
import WorkflowFormDialog from 'src/components/forms/WorkflowForm/WorkflowFormDialog';
import GridLayoutComponent from 'src/components/GridLayoutComponent/GridLayoutComponent';
import moment from 'moment';
import axios from 'axios'
import { APIURL } from '../../../config'

const SupportCoordinationEmployeeHome = (props) => {
    const [dataLoading, setDataLoading] = useState(true);
    const [sDataLoading, setSDataLoading] = useState(true);
    const [value, setValue] = useState('1');
    const [data, setData] = useState(null);
    const [sData, setSData] = useState(null);

    const [showAddNote, setShowAddNote] = useState(false);
    const [showUpload, setShowUpload] = useState(false);
    const [showTask, setShowTask] = useState(false);
    const [showTimesheet, setShowTimesheet] = useState(false);
    const [showWorkflow, setShowWorkflow] = useState(false);

    const [noteCustomerID, setNoteCustomerID] = useState();
    const [uploadCustomerID, setUploadCustomerID] = useState("");
    const [timesheetCustomerID, setTimesheetCustomerID] = useState("")

    const fetchRowsRef = useRef(null);
    const registerFetchRows = useCallback((fetcher) => {
        fetchRowsRef.current = fetcher || null;
    }, []);

    const handleShowNote = (id) => { setNoteCustomerID(id); setShowAddNote(true) };
    const handleShowUpload = (id) => { setUploadCustomerID(id); setShowUpload(true) };
    const handleShowTask = () => setShowTask(true);
    const handleCloseTask = () => setShowTask(false);
    const handleShowTimesheet = (id) => { setTimesheetCustomerID(id); setShowTimesheet(true) };
    const handleCloseTimesheet = () => setShowTimesheet(false);

    const isAdmin = props.user.type === 'Admin';
    const isSubscibedToTimeManagement = props.user.subs.find((setting) => setting.feature_id === 12) ? true : false;
    const isSubscibedToBIandReporting = props.user.subs.find((setting) => setting.feature_id === 16) ? true : false;

    useEffect(() => {
        const fetchData = async () => {
            props.checkTokenExpiry();
            await getEmployees();
        };
        fetchData();
    }, [props])

    const handleTimesheetCreated = () => {
        fetchRowsRef.current?.({ skipCache: true });
        getEmployees();
    };

    const getEmployees = async () => {
        let data = await axios.get(APIURL + "/monthlymonitoring/manager/data", {
            params: {
                comp_id: props.comp_id,
                emp_id: props.user.emp_id,
                start: moment().subtract(2, 'months').startOf('month').format('YYYY-MM-DD'),
                end: moment().endOf('month').format('YYYY-MM-DDT23:59:59')
            }
        });

        setData(data.data);
        console.log(data.data);
        setDataLoading(false);
    }

    const getSCH = async () => {
        let data = await axios.get(APIURL + "/customers/SCH", {
            params: {
                comp_id: props.comp_id,
                emp_id: props.user.emp_id,
                start: moment().subtract(11, 'months').startOf('month').format('YYYY-MM-DD'),
                end: moment().endOf('month').format('YYYY-MM-DDT23:59:59'),
            }
        });
        setSData(data.data)
        setSDataLoading(false);
        console.log(data.data)
    }

    return (
        <div>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Tabs
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    value={value}
                >
                    <Tab onClick={() => setValue('1')} label="Home" value="1" />
                    <Tab onClick={() => setValue('2')} label="Caseload Report" value="2" />
                    {isSubscibedToTimeManagement && <Tab onClick={() => setValue('3')} label="Timesheets Report" value="3" />}
                    {isAdmin && isSubscibedToBIandReporting && <Tab onClick={() => setValue('4')} label="Dashboard" value="4" />}
                    {props.user.type !== 'Fieldworker' && <Tab onClick={() => setValue('5')} label="DDD Sync" value="5" />}
                    <Tab onClick={() => setValue('6')} label="SC Management" value="6" />
                    <Tab onClick={() => setValue('7')} label="Customers" value="7" />
                </Tabs>
                <ButtonGroup size="small" sx={{ height: "40px", whiteSpace: "nowrap" }}>
                    <Button variant="contained" onClick={() => setShowAddNote(true)}>NEW NOTE</Button>
                    && <Button variant="contained" onClick={handleShowTask}>NEW TASK</Button>
                    {isSubscibedToTimeManagement && <Button variant="contained" onClick={handleShowTimesheet}>NEW TIMESHEET</Button>}
                    {props.user.permissions.CreateNewWorkflow && <Button size="small" variant="contained" onClick={() => setShowWorkflow(true)}>NEW WORKFLOW</Button>}
                    <Button size="small" variant="contained" onClick={() => setShowUpload(true)}>UPLOAD</Button>
                </ButtonGroup>
            </div>
            {value === '1' &&
                <GridLayoutComponent
                    {...props}
                    checkTokenExpiry={props.checkTokenExpiry}
                    user={props.user}
                    comp_id={props.comp_id}
                    onRegisterFetchRows={registerFetchRows}
                    handleShowNote={handleShowNote}
                    handleShowUpload={handleShowUpload}
                    handleShowTimesheet={handleShowTimesheet}
                    sData={sData ? sData : []}
                    sDataLoading={sDataLoading}
                    data={data ? data : []}
                    getSCH={getSCH}
                    getEmployees={getEmployees}
                    dataLoading={dataLoading}
                />
            }
            {value === '2' &&
                (isAdmin ?
                    <div style={{ width: '100%' }}>
                        <MTSummaryReport user={props.user} source={'Home'} />
                    </div>
                    :
                    <div>
                        <CaseloadReport user={props.user} pagesize={20} comp_id={props.comp_id} />
                    </div>
                )
            }
            {value === '3' &&
                <div style={{ width: '98%' }}>
                    <TimesheetsReport user={props.user} pagesize={20} comp_id={props.comp_id} />
                </div>
            }
            {value === '4' &&
                <div>
                    <Home {...props} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id} />
                </div>
            }
            {value === '5' &&
                <div>
                    <IRecordSync comp_id={props.comp_id} {...props}></IRecordSync>
                </div>
            }
            {value === '6' &&
                <div>
                    <SupportCoordinatorManagement {...props} handleShowNote={handleShowNote} handleShowUpload={handleShowUpload} data={data ? data : []} comp_id={props.comp_id} emp_id={props.user.emp_id} getSCH={getSCH} getEmployees={getEmployees} loading={dataLoading} />
                </div>
            }
            {value === '7' &&
                <div>
                    <SupportCoordinatorCustomers
                        {...props}
                        handleShowNote={handleShowNote}
                        handleShowUpload={handleShowUpload}
                        handleShowTimesheet={handleShowTimesheet}
                        onRegisterFetchRows={registerFetchRows}
                        data={sData ? sData : []}
                        comp_id={props.comp_id}
                        emp_id={props.user.emp_id}
                        loading={sDataLoading}
                        isSubscibedToTimeManagement={isSubscibedToTimeManagement}
                    />
                </div>
            }
            <div>
                <NewNote checkTokenExpiry={props.checkTokenExpiry} showAddNote={showAddNote} setShowAddNote={setShowAddNote} company_id={props.comp_id} mode='add' user={props.user} customer_id={noteCustomerID} setNoteCustomerID={setNoteCustomerID}></NewNote>
                <NewTask show={showTask} handleClose={handleCloseTask} user={props.user} emp_id={props.user.emp_id} comp_id={props.comp_id} {...props} />
                {isSubscibedToTimeManagement && <NewTimesheet show={showTimesheet} handleClose={handleCloseTimesheet} comp_id={props.comp_id} user={props.user} emp_id={props.user.emp_id} customer_id={timesheetCustomerID} setTimesheetCustomerID={setTimesheetCustomerID} onTimesheetCreated={handleTimesheetCreated}></NewTimesheet>}
                <WorkflowFormDialog {...props} open={showWorkflow} handleClose={() => setShowWorkflow(false)} />
                <Upload showUpload={showUpload} setShowUpload={setShowUpload} company_id={props.comp_id} user={props.user} customer_id={uploadCustomerID} setUploadCustomerID={setUploadCustomerID} rerender={getSCH}></Upload>
            </div>
        </div>
    )
}

export default SupportCoordinationEmployeeHome;